<template>
    <div class="d-flex gap-2 mr-5">
        <!-- Direct Buttons -->
        <v-btn v-for="(action, index) in visibleActions" :key="'visible-' + index"
            :data-cy="action.dataCy || 'action-' + index" density="compact" :color="action.color || 'primary'"
            :variant="action.variant || 'flat'" :class="action.class || ''" @click="emitAction(action.event)">
            {{ $t(action.label) }}
        </v-btn>

        <!-- Menu for hidden actions -->
        <v-menu v-if="hiddenActions.length" offset-y>
            <template v-slot:activator="{ props }">
                <v-btn v-bind="props" data-cy="actions-menu" density="compact" icon :variant="'flat'">
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>

            <v-list>
                <v-list-item v-for="(action, index) in hiddenActions" :key="'hidden-' + index"
                    :data-cy="action.dataCy || 'action-menu-' + index" @click="emitAction(action.event)">
                    <v-list-item-title>{{
                        $t(action.label)
                        }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
import emitter from "@/eventBus";

export default {
    name: "FormActions",
    props: {
        actions: {
            type: Array,
            required: true,
        },
    },
    computed: {
        visibleActions() {
            return this.actions.filter((a) => !a.menu);
        },
        hiddenActions() {
            return this.actions.filter((a) => a.menu);
        },
    },
    methods: {
        emitAction(eventName) {
            if (eventName) {
                emitter.emit(eventName);
            }
        },
    },
};
</script>
